const tableMetadata = [
  {
    id: 'businessAccount',
    renderingField: 'businessAccount',
    width: '25%',
    numeric: false,
    disablePadding: false,
    label: 'Business account',
    alignment: 'left',
  },
  {
    id: 'fee',
    renderingField: 'formattedFee',
    width: '25%',
    numeric: false,
    hideInMobile: true,
    disablePadding: false,
    label: 'Suspension fee (Weekly)',
    alignment: 'left',
  },
  {
    id: 'duration',
    renderingField: 'formattedDuration',
    width: '25%',
    numeric: false,
    hideInMobile: true,
    disablePadding: false,
    label: 'Allowed suspension period (Weeks)',
    alignment: 'left',
  },
  {
    id: 'admin',
    renderingField: 'admin',
    width: '25%',
    numeric: false,
    disablePadding: false,
    label: '',
    alignment: 'right',
  },
];

export default tableMetadata;
